import { z } from "zod";
import { utcDatetime } from "../../../helpers/date";
import { AgentAccessGrantTargetSchema } from "../agentAccess/agent-access-grant.schema";

export const McpConnectionSchema = z.object({
    id: z.string().uuid(),
    clientId: z.string(),
    clientName: z.string(),
    scopes: z.array(z.string()),
    grantTarget: AgentAccessGrantTargetSchema.nullable(),
    lastUsedAt: utcDatetime.nullable(),
    revokedAt: utcDatetime.nullable(),
    createdAt: utcDatetime,
});

export type McpConnection = z.infer<typeof McpConnectionSchema>;

export const ListMcpConnectionsResponseSchema = z.object({
    connections: z.array(McpConnectionSchema),
});

export const McpConnectionIdPathParamsSchema = z.object({
    id: z.string().uuid(),
});
